module.exports = __webpack_public_path__ + "static/media/wechatAlipay.f3350159.png";